import { ApiClientInstance } from '@shared/api';
import { InsuranceAssetType } from '@entities/investments';

import { TAgreementsResponse, TInsuranceConfigurationsResponse, TUpdateProfile } from './types';

export const getInsuranceProfile = () => {
  return ApiClientInstance.get<void>(`v2/investment/insurance/profile`);
};

export const submitInsuranceProfile = (data: TUpdateProfile) =>
  ApiClientInstance.post<TUpdateProfile, void>('v2/investment/insurance/profile', data);

export const getInsuranceAgreements = () => {
  return ApiClientInstance.get<TAgreementsResponse>(`v2/investment/insurance/agreements`);
};

export const getInsuranceConfigurations = (assetType: InsuranceAssetType) => {
  return ApiClientInstance.get<TInsuranceConfigurationsResponse>(
    `v2/investment/insurance/${assetType}/configurations`
  );
};
